export const creditTags = ['credits_Add'] as const;
